import React, { FC } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {TrackOwnProps, TrackView} from './TrackView';

const SortableTrackView: FC<TrackOwnProps> = (props) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging,
        transform,
        transition
    } = useSortable({ id: props.track.id, disabled: !props.isBlockDragonDrop });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition: transition || undefined,
        cursor: isDragging ? 'grabbing' : 'grab',
        boxShadow: isDragging  ? 'rgb(63 63 68 / 5%) 0px 2px 0px 2px, rgb(34 33 81 / 15%) 0px 2px 3px 2px' : undefined,
    };
    return (
      <TrackView
        ref={setNodeRef}
        {...props}
        style={style}
        {...attributes}
        {...listeners}
      />
    );
};

export default SortableTrackView;
